import { render, staticRenderFns } from "./daojishi.vue?vue&type=template&id=4de3b770&scoped=true"
import script from "./daojishi.vue?vue&type=script&lang=js"
export * from "./daojishi.vue?vue&type=script&lang=js"
import style0 from "./daojishi.vue?vue&type=style&index=0&id=4de3b770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de3b770",
  null
  
)

export default component.exports